import { render, staticRenderFns } from "./trusted-device-edit-name.vue?vue&type=template&id=15b7a925&scoped=true&"
import script from "./trusted-device-edit-name.vue?vue&type=script&lang=js&"
export * from "./trusted-device-edit-name.vue?vue&type=script&lang=js&"
import style0 from "./trusted-device-edit-name.vue?vue&type=style&index=0&id=15b7a925&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b7a925",
  null
  
)

export default component.exports